import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  CircularProgress,
} from '@mui/material';
import { observer } from 'mobx-react';
import { useZReport } from '../stores/FetcherStores/ZReportFetcher';

interface ZReportDetailsProps {
  companyId: string;
  reportId: string;
  registerKey?: string;
}

const ZReportDetails = ({ companyId, reportId, registerKey }: ZReportDetailsProps) => {
  const { data: zReport, isLoading, error } = useZReport(companyId, reportId, registerKey);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} color="secondary" />
      </Box>
    );
  }

  if (error || !zReport) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="error">
          Kunde inte ladda z-rapport data
        </Typography>
      </Box>
    );
  }

  const rows = zReport.report.csv
    .split('\n')
    .filter((row: string) => row.trim())
    .map((row: string) => row.split(';'));

  return (
    <Box sx={{ margin: 1 }}>
      <Table size="small">
        <TableBody>
          {rows.map((row, rowIndex) => {
            const rowKey = `row-${reportId}-${row.join('-')}`;
            return (
              <TableRow key={rowKey} sx={{ '& > *': { borderBottom: 'none' } }}>
                {row.map((cell) => {
                  const cellKey = `cell-${reportId}-${rowIndex}-${cell}`;
                  return <TableCell key={cellKey}>{cell}</TableCell>;
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

export default observer(ZReportDetails);
